const PhoneCode = {
  CN: 86,
  US: 1,
  JP: 81,
};

// 上线国家添加对应country code
const enableCountry = ['US', 'CN', 'JP'];
const isValidTradeupCountry = (country) => {
  return enableCountry.includes(country.code);
};

// 版首图
const banner = {
  'zh_cn': {
    src_mob: 'https://res.insta360.com/static/07753be8b4a1cae12fbebb6e497c1eef/TradeupBlogGO2MO_SC1125_588.png',
    src: 'https://res.insta360.com/static/8d31d47d70a5081877fb8c1a6ba538cd/TradeupBlogGO2PC_SC3840_562.jpg',
  },
  'en_us': {
    src_mob: 'https://res.insta360.com/static/8f61f4bd205a3f18c89c245462fc29a7/TradeupBlogGO2MO_EN1125_588.png',
    src: 'https://res.insta360.com/static/3eb48e1fd81cdbb852e71df1365291ee/TradeupBlogGO2PC_EN3840_562.jpg',
  },
  'ja_jp': {
    src_mob: 'https://res.insta360.com/static/c8cd133697af9ffb719f9b8020c5589c/TradeupBlogGO2MO_JP1125_588.png',
    src: 'https://res.insta360.com/static/81953d31257fbe61e1dedee325b079bc/TradeupBlogGO2PC_JP3840_562.jpg',
  },
};

// 产品页展示入口
const ENABLED_TRADEUP_PRODUCT = [13, 15];

/**
 * 根据地区和产品判断当前产品能不能以旧换新
 * @param {*} code
 * @param {*} pid
 */
const enableProductPage = (code, pid) => {
  if (enableCountry.includes(code) && ENABLED_TRADEUP_PRODUCT.includes(pid)) {
    return true;
  }
  return false;
};

export { isValidTradeupCountry, PhoneCode, banner, ENABLED_TRADEUP_PRODUCT, enableProductPage };
